export default __webpack_public_path__ + "static/media/Logo-Header-Drop-shadow.a86e7b30.png";